import React from 'react'
import { Hide } from 'pcln-design-system'
import useRecentSearchAndTripData from '@/hooks/useRecentSearchAndTripActivityData'
import { type Booking } from '@/components/CrossSell/types'
import useExtendStayBooking, {
  type ExtendStayBooking
} from '@/hooks/useExtendStayBooking'
import RecentSearchCards from '@/components/RecentSearchCards'
import useMostRecentFutureBooking from '@/hooks/useMostRecentFutureBooking'
import ExtendStay from '@/components/ExtendStay'
import CrossSell from '@/components/CrossSell'
import useSeti from '@/hooks/useSeti'

function RecentSearch({
  extendData
}: {
  extendData: ExtendStayBooking | null
}) {
  const { firstFiveCards, showHotelSelection, recentActivityData } =
    useRecentSearchAndTripData()
  return !extendData ? (
    <RecentSearchCards
      firstFiveCards={firstFiveCards}
      showHotelSelection={showHotelSelection}
      recentActivityData={recentActivityData}
    />
  ) : null
}

function UpcomingTrip({
  mostRecentFutureBooking,
  extendData,
  ...props
}: {
  mostRecentFutureBooking?: Booking | null
  extendData: ExtendStayBooking | null
} & Record<string, unknown>) {
  return (
    (extendData || mostRecentFutureBooking) && (
      <Hide md {...props}>
        {extendData ? (
          <ExtendStay {...extendData} />
        ) : (
          mostRecentFutureBooking && (
            <CrossSell booking={mostRecentFutureBooking} />
          )
        )}
      </Hide>
    )
  )
}

export default function TripDisplayOrder() {
  const { mostRecentFutureBooking, isWithin7Days } =
    useMostRecentFutureBooking()
  const extendData = useExtendStayBooking()
  const isUpcomingTripsReorder =
    useSeti('HP_REORDER_TRIPS', isWithin7Days) === 'VARIANT' && isWithin7Days
  return isUpcomingTripsReorder ? (
    <>
      <UpcomingTrip
        extendData={extendData}
        mostRecentFutureBooking={mostRecentFutureBooking}
        mb={4}
      />
      <RecentSearch extendData={extendData} />
    </>
  ) : (
    <>
      <RecentSearch extendData={extendData} />
      <UpcomingTrip
        extendData={extendData}
        mostRecentFutureBooking={mostRecentFutureBooking}
      />
    </>
  )
}
